import React from "react";
const IconSevere = ({
  className
}) => {
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "#00BFD6",
    rx: "12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17.75 15c-.689 0-1.25-.56-1.25-1.25V11.5c0-1.82-1.12-3.476-2.802-4.162C13.511 6.554 12.818 6 12 6c-.806 0-1.512.566-1.7 1.338-1.68.686-2.8 2.341-2.8 4.162v2.25c0 .69-.561 1.25-1.25 1.25-.138 0-.25.112-.25.25s.112.25.25.25h11.5c.138 0 .25-.112.25-.25s-.112-.25-.25-.25M13.5 16h-3c-.138 0-.25.112-.25.25 0 .965.785 1.75 1.75 1.75s1.75-.785 1.75-1.75c0-.138-.112-.25-.25-.25"
  })));
};
export default IconSevere;